module.exports = __webpack_public_path__ + "img/logo-google.0dd54f85.png";